import React, { useEffect, useState } from 'react';
import '../../Styles/Styles.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom'; 
import { useCookies } from 'react-cookie';
import { toast } from 'react-toastify';
import CssClass from "../../Styles/common.module.css";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { GetPageAuthorityFn } from "../../Common/authority";
import CreateRole from "../../Components/Users/Role/InsertRole";
import RoleUpdate from '../../Components/Users/Role/RoleUpdate';
import RoleDelete from '../../Components/Users/Role/RoleDelete';
import RoleActivator from '../../Components/Users/Role/RoleActivator';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePlus, faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode, FilterService } from 'primereact/api';
import { Calendar } from 'primereact/calendar';

const PAGE_NAME = "Role.js";
const MODULE_ID = "WEB_URS_003";

const Role = (props) => {
  const navigate = useNavigate();
  const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
  const [showCreateRole, setShowCreateRole] = useState(false);
  const [showActivator, setShowActivator] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedRole, setSelectedRole] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading....")
  const [reload, setReload] = useState(false);
  const [allData, setAllData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    ROLE_NAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
    UPDATE_DATETIME: { value: null, matchMode: 'customDateRange' },
    USERNAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  //#region Authority
  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
    READALL: "N",
  });
    
  useEffect(() => {
    let promise = GetPageAuthorityFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Dashboard");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
          READALL: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
        toast.error(error);
        navigate("/Dashboard");
      }
    );
  }, [userId, navigate]);
  //#endregion

  useEffect(() => {
    if(actionAuthority.READ === 'Y') {
      let functionName = "useEffect Get Role List";
      try {
        setLoading(true);
        setLoadingText("Getting Role List, Please wait...");
        setAllData([]);

        const listItems = [];

        http
          .get("api/role/GetAllRoles?_sysUser=" + userId, 
              { timeout: 100000})
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data) => {
                const date = new Date(data.UPDATE_DATETIME);

                listItems.push({
                  key: data.ROLE_ID,
                  ROLE_ID: data.ROLE_ID,
                  ROLE_NAME: data.ROLE_NAME,
                  REMARK: data.REMARK,
                  STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                  UPDATE_DATETIME: date,
                  USERNAME: data.USERNAME,
                });
              });
            }
            setAllData(listItems);
          })
        .catch((err) => {
          toast.error("Error on getting role list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
      } catch (err) {
        toast.error("Error on getting role list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

	const onReloadHandler = () => {
    setReload(!reload);
  };

  const createRoleModal = () => {
    setShowCreateRole(!showCreateRole);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const showUpdateModal = (e, row) => {
    setShowUpdate(!showUpdate);
    setEditData(row);
  };

  const hideUpdateModal = () => {
    setShowUpdate(!showUpdate);
    setEditData(null);
  };

  const showDeleteModal = (row) => {
    setShowDelete(true);
    setEditData(row);
  };

  const hideDeleteModal = () => {
    setShowDelete(false);
    setEditData(null);
  };
  
	const showActivatorModal = (e, row) => {
    setShowActivator(!showActivator);
    setEditData(row);
  };

  const hideActivatorModal = () => {
    setShowActivator(!showActivator);
    setEditData(null);
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    if (!_filters['global']) {
      _filters['global'] = { value: null, matchMode: FilterMatchMode.CONTAINS };
    }

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
    
  const renderHeader = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <span className="text-lg font-semibold" style={{ fontSize: '22px' }}>Roles</span>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search"
            className="table-search-input"
            style={{ height: '40px', fontSize: '0.9rem' }}
          />
        </IconField>
      </div>
    );
  };

  const HighlightCell = ({ text, keyword }) => {
    if (!keyword || !text) return text;

    const regex = new RegExp(`(${keyword})`, "gi");
    const parts = text.split(regex);

    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === keyword.toLowerCase() ? (
            <span key={i} className="highlight-keyword">{part}</span>
          ) : (
            part
          )
        )}
      </>
    );
  };

  FilterService.register('customDateRange', (value, filters) => {
    if (!filters || filters.length !== 2) return true;

    const [startDate, endDate] = filters;

    if (!value || !(value instanceof Date)) return false;

    const valueDate = new Date(value);
    valueDate.setHours(0, 0, 0, 0);

    if (startDate) {
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      if (valueDate < start) return false;
    }

    if (endDate) {
      const end = new Date(endDate);
      end.setHours(0, 0, 0, 0);
      if (valueDate > end) return false;
    }

    return true;
  });
	//#endregion

  return (
    <>
    <div className={`${CssClass.cardTwo} ${CssClass.tableCardTwo}`}>
      <div style={{ width: "100%" }}>
        <DataTable value={allData} dataKey="ROLE_ID" header={renderHeader()} globalFilter={globalFilterValue} globalFilterFields={['ROLE_NAME', 'USERNAME']} filters={filters} filterDisplay="row" 
          onFilter={(e) => { 
            const newFilters = e.filters; 
            setFilters(newFilters); 
            const globalKeyword = newFilters.global?.value || '';
            const updated = allData.map(item => ({ ...item, __FILTER_KEYWORD__: { ROLE_NAME: newFilters.ROLE_NAME?.value || globalKeyword, USERNAME: newFilters.USERNAME?.value || globalKeyword }})); 
            setAllData(updated); 
          }}
          selectionMode="multiple" selection={selectedRole} onSelectionChange={(e) => setSelectedRole(e.value)}
          loading={loading} removableSort emptyMessage="No roles found." first={currentPage * rowsPerPage}
          paginator rows={rowsPerPage} onPage={(e) => { setCurrentPage(e.page); setRowsPerPage(e.rows); }} rowsPerPageOptions={[10, 20, 30, 40, 50]} 
          scrollable showGridlines className="datatable" tableStyle={{ minWidth: '50rem' }}
        >
          <Column
            header="Action"
            {...(actionAuthority.WRITE === 'Y' && {
              filter: true,
              filterElement: (
                <button
                  onClick={createRoleModal}
                  style={{
                    alignItems: 'center',
                    marginLeft: '30px',
                    padding: '8px',
                    width: '90px',
                    borderRadius: '5px',
                    color: 'white',
                    backgroundColor: '#1873e1',
                  }}
                >
                  <FontAwesomeIcon icon={faSquarePlus} />
                  <span>&nbsp; ADD</span>
                </button>
              ),
              showFilterMatchModes: false,
              showFilterOperator: false,
              showFilterMenu: false,
            })}
            body={(rowData) => (
              <div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
                  {(actionAuthority.WRITE === "Y")&& (
                    <span title="Modify">
                      <Comp.Button
                        id="btnEdit"
                        type="general"
                        onClick={(e) => showUpdateModal(e, rowData)}
                        style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
                      >
                        <FontAwesomeIcon icon={faPenToSquare} />
                      </Comp.Button>
                    </span>
                  )}
                  {(actionAuthority.WRITE === "Y")&& (
                    <span title="Delete">
                      <Comp.Button
                        id="btnDelete"
                        type="delete"
                        onClick={() => showDeleteModal(rowData)}
                        style={{ width: "50px", height: "35px" }}
                      >
                        <FontAwesomeIcon icon={faTrashCan} />
                      </Comp.Button>
                    </span>
                  )}
              </div>
            )}
          />
          <Column
            header="#"
            body={(rowData, options) => options.rowIndex + 1}
            style={{ width: '3rem', height: "40px", textAlign: 'center' }}
          />
          <Column field="ROLE_NAME" header="Role Name" filter filterPlaceholder="Search by name" sortable
            body={(rowData) => (
              <HighlightCell text={rowData.ROLE_NAME} keyword={rowData.__FILTER_KEYWORD__?.ROLE_NAME || ''} />
            )}
          />
          <Column
            field="STATUS"
            header="Status"
            sortable
            style={{ textAlign: 'center' }}
            body={(rowData) => {
              const className =
                rowData.STATUS === "Active"
                  ? CssClass.activeStatus
                  : CssClass.inactiveStatus;

              const handleToggle = (e, rowData) => {
                showActivatorModal(e, rowData);
              };

              return (
                <div className={CssClass.toggleWrapper}>
                  <label className={CssClass.switch}>
                    <input
                      type="checkbox"
                      checked={rowData.STATUS === "Active"}
                      onChange={(e) => handleToggle(e, rowData)}
                    />
                    <span className={CssClass.sliderRound}></span>
                  </label>
                </div>
              );
            }}
          />
          <Column field="UPDATE_DATETIME" header="Last Update" sortable filter filterMatchMode="customDateRange" showFilterMatchModes={false} showFilterOperator={false} showFilterMenu={false} 
            filterElement={(options) => (
              <Calendar
                value={options.value}
                onChange={(e) => options.filterApplyCallback(e.value)}
                selectionMode="range"
                dateFormat="dd/mm/yy"
                placeholder="Select date"
                readOnlyInput
              />
            )}
            body={(rowData) => {
              const date = rowData.UPDATE_DATETIME;
              if (!date) return '';

              const d = new Date(date);
              const dd = d.getDate().toString().padStart(2, '0');
              const mm = (d.getMonth() + 1).toString().padStart(2, '0');
              const yyyy = d.getFullYear();

              let hours = d.getHours();
              const minutes = d.getMinutes().toString().padStart(2, '0');
              const ampm = hours >= 12 ? 'PM' : 'AM';
              hours = hours % 12 || 12;

              return `${dd}/${mm}/${yyyy} ${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
            }}>
          </Column>
          <Column field="USERNAME" header="Updated By" filter filterPlaceholder="Search by username" sortable 
            body={(rowData) => (
              <HighlightCell text={rowData.USERNAME} keyword={rowData.__FILTER_KEYWORD__?.USERNAME || ''} />
            )}
          />
        </DataTable>
      </div>
      <br/>
    </div>

    {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
    <Comp.AlertPopup />
        
    <CreateRole
      page={props.page}
      module={MODULE_ID}
      showHide={showCreateRole}
      onHide={createRoleModal}
      onReload={onReloadHandler}
      onLoading={onLoadingHandler}
    />

    <RoleUpdate
      page={props.page}
      module={MODULE_ID}
      showHide={showUpdate}
      editData={editData}
      onHide={hideUpdateModal}
      onReload={onReloadHandler}
      onLoading={onLoadingHandler}
    />

    {showDelete && (
      <RoleDelete
        page={props.page}
        module={MODULE_ID}
        showHide={showDelete}
        editData={editData}
        onHide={hideDeleteModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
    )}

    {showActivator && (
      <RoleActivator
        page={props.page}
        module={MODULE_ID}
        showHide={showActivator}
        editData={editData}
        onHide={hideActivatorModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
    )}
    </>
  );
};

export default Role;
